import { useState } from 'react'
import ClassName from 'clsx'
import Styles from './style.module.scss'
import { Flex } from 'antd'
import { SolutionMedicalProps } from '@/assets/content/type'
type CardProps = SolutionMedicalProps['projects']['items'][number]

export const Card = ({ title, descriptions, image }: CardProps) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className={ClassName(Styles.card, isHovered && Styles.hovered)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
      <h5 className={Styles.cardTitle}>{title}</h5>
      {isHovered && !!descriptions?.length && (
        <div className={Styles.cardContent}>
          {descriptions?.map((text, index) => (
            <span key={index}>{text}</span>
          ))}
        </div>
      )}
    </div>
  )
}

export const CardsGrid = ({ data }) => {
  return (
    <div className={Styles['cards-grid']}>
      {data?.map((card, index) => (
        <Card key={index} {...card} />
      ))}
    </div>
  )
}

export default function Index({ data }) {
  return <CardsGrid data={data} />
}
